// extracted by mini-css-extract-plugin
module.exports = {"container":"Notification_container__3pfRZ","notification":"Notification_notification__2t3DA"};